import { Component, ViewChild } from "@angular/core";
import { expandingFabAnimations } from "@/_utility/animations";
import { PerformanceLegacyComponent } from "./performance-legacy/performance-legacy.component";
import { OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { PerformanceOverviewComponent } from "./performance-overview/performance-overview.component";

@Component({
    templateUrl: "./statistics.component.html",
    styleUrls: ["./statistics.component.scss"],
    animations: [expandingFabAnimations],
})
export class StatisticsComponent {
    isBeta: boolean = true;
    showSwitch: boolean = false;
    resetLegacyAssessment: boolean = false;

    @ViewChild(PerformanceLegacyComponent)
    legacyComponentRef: PerformanceLegacyComponent;

    constructor(private route: ActivatedRoute) {}

    @ViewChild(PerformanceOverviewComponent)
    performanceOverviewComponent?: PerformanceOverviewComponent;

    ngOnInit(): void {
        this.route.queryParamMap.subscribe((params) => {
            const classicView = params.get("classicView");
            if (classicView === "true") {
                this.isBeta = false;
                this.showSwitch = true;
            }
        });
    }

    toggleBetaView() {
        this.isBeta = !this.isBeta;
        if (
            this.legacyComponentRef &&
            this.legacyComponentRef.resetAssessmentFilter
        ) {
            this.legacyComponentRef.resetAssessmentFilter();
        }
    }

    exportInsightsPDF() {
        if (this.isBeta && this.performanceOverviewComponent) {
            this.performanceOverviewComponent.exportPDF();
        }
    }
}
